// prefer default export if available
const preferDefault = m => m && m.default || m

exports.components = {
  "component---src-pages-404-js": () => import("/builds/atomix/candidate-projects/base/frontend/src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-pages-index-js": () => import("/builds/atomix/candidate-projects/base/frontend/src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */),
  "component---src-pages-page-2-js": () => import("/builds/atomix/candidate-projects/base/frontend/src/pages/page-2.js" /* webpackChunkName: "component---src-pages-page-2-js" */)
}

